<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>ANALYZING</p>
			<p class="login-subtitle">Smart player scouting</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Improve your ability to find and select the right players for your team with TiroLibre's platform:</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Improve your team's player selection with TiroLibre:</p>
			<p class="login-text">- Discover potential talents fitting your team style.</p>
			<p class="login-text margin-list">- Evaluate players with verified data and insights.</p>
			<p class="login-text margin-list">- Use the negotiation room to discuss contracts.</p>
			<p class="login-text margin-list">- Make informed decisions and reduce risk.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">With TiroLibre's advanced technology and innovative solutions, you can streamline your transfer market strategy and make data-driven decisions, increasing your team's chances of success.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">TiroLibre's advanced technology and innovative solutions can help streamline your transfer market strategy and increase your team's chances of success. Join now.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-4 button-box' : 'p-lg-2 button-box'" style="padding: 0px">
				<Button label="Start scouting" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeTeam2ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-6 button-box-mobile" style="margin-top: -10px; margin-bottom: 30px">
				<Button label="Start scouting" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

.margin-list {
	margin-top: -20px;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}

	.margin-list {
		margin-top: -15px;
	}
}
</style>